import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import axios from "../../../../../axios";
import CompletedASList from "../../../On_going/Published/Published_Q_list/CompletedASList";
import { Popup } from "semantic-ui-react";
import PdfQTypeActivity from "../../../On_going/Published/Published_Q_list/PublishQuestionType/PdfType/PdfQTypeActivity";
import AttachActivity from "../../../Create_Assessment_Activity/create/AttachActivity";
import { Form } from "react-bootstrap";
import SuccessfullReviewActivity from "./SuccessReviewActivity";
import ConfiramationPopup from "../ConfiramationPopup";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@mui/material";
import { Box } from "lucide-react";

const QuestionnoboxC = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [attachMent, setAttachment] = useState([]);
  const [openPopup, setOpenPopup] = useState(false);

  const [reviewData, setReviewData] = useState({
    reviewSdata: [],
    completedSList: [],
  });
  const [inProgress, setInProgress] = useState(false);
  const [success, setSuccess] = useState(false);

  const [isValidFileType, setIsValidFileType] = useState(true);

  const { reviewSdata, completedSList } = reviewData;
  const [openMissingScoreDialog, setOpenMissingScoreDialog] = useState(false);

  // 🔥 Get entryType and gradeScaleId from state (passed from StudentTableActivityReview)
  const entryType = state?.entryType || "Marks";
  const gradeScale = state?.gradeScaleId || null;

  // State for grade selection
  const [selectedGrade, setSelectedGrade] = useState("");

  useEffect(() => {
    const getReviewActivity = async () => {
      try {
        const reviewSdata = await axios.get(
          `/api/v1/homework/activity/${state.reviewActivity_id}/studentResponse/getByStudentAndActivityId/${state.student_id}`,
        );

        const completedSList = await axios.get(
          `/api/v1/homework/studentActivity/getByAcivityId/${state.reviewActivity_id}?status=completed`,
        );
        reviewSdata &&
          completedSList &&
          setReviewData({
            reviewSdata: reviewSdata.data.data,
            completedSList: completedSList.data.data,
          });
      } catch (error) {}
    };
    getReviewActivity();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const teacher_id = reviewSdata?.activity_id?.teacher_id?.id;
  const response_id = reviewSdata?.id;
  const [inputField, setInputField] = useState({
    obtainedMarks: "",
    addComment: "",
    attach: [],
  });

  const { obtainedMarks, addComment, attach } = inputField;

  const totalMarks = reviewSdata?.activity_id?.total_marks || 0;

  // Helper function to get grade from marks
  const getGradeFromMarks = (marks) => {
    if (!gradeScale || !gradeScale.grades) return null;

    const numericMarks = Number(marks);
    const foundGrade = gradeScale.grades.find(
      (g) => numericMarks >= g.minMarks && numericMarks <= g.maxMarks,
    );
    return foundGrade || null;
  };

  // Handle grade selection
  const handleGradeSelect = (grade) => {
    setSelectedGrade(grade.grade);
    // Auto-set marks based on grade (use min marks as default)
    setInputField({
      ...inputField,
      obtainedMarks: grade.minMarks.toString(),
    });
  };

  let reviewResponse = {
    teacher_id,
    student_id: reviewSdata?.student_id?.id,
    total_marks: totalMarks,
    status: "completed",
    comment: addComment,
    attachments: attach,
    ...(entryType === "Grade"
      ? { obtained_grade: selectedGrade }
      : {
          obtained_marks:
            Number(totalMarks) === 0
              ? 0
              : obtainedMarks === ""
                ? 0
                : obtainedMarks,
        }),
  };

  const validateFileType = (filePath) => {
    var allowedExtensions =
      /(\.jpg|\.jpeg|\.png|\.pdf|\.mp3|\.mp4|\.pptx|\.ppt)$/i;

    if (!allowedExtensions.exec(filePath.name)) {
      setIsValidFileType(false);
      return false;
    }
    setIsValidFileType(true);
    return true;
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    let totalSize = attachMent.reduce((acc, file) => acc + file.size, 0);

    if (totalSize + file.size <= 10 * 1024 * 1024 && validateFileType(file)) {
      const formData = new FormData();
      formData.append("uploadActivityAttachment", file);

      axios
        .post(
          `/api/v1/homework/activity/uploadAttachment/teacherId/${teacher_id}`,
          formData,
        )
        .then((response) => {
          setAttachment((prev) => [...prev, file]);
          reviewResponse.attachments = response.data.data;
          setInputField({
            ...inputField,
            attach: [...inputField.attach, response.data.data],
          });
        })
        .catch((error) => {
          console.error("Error uploading file:", error);
        });
    } else {
      setIsValidFileType(false);
    }
  };

  const handleSubmit = async () => {
    setInProgress(true);
    try {
      const res = await axios.post(
        `/api/v1/homework/activity/${state.reviewActivity_id}/studentResponse/${response_id}/studentResult/create`,
        reviewResponse,
      );
      if (res) {
        setInProgress(false);
        setSuccess(true);
        navigate("/StudentListActivity", {
          state: { reviewActivity_id: state.reviewActivity_id },
        });
      }
    } catch (error) {
      setInProgress(false);
    }
  };

  const CheckUnAttemptedQuestionsByTeacher = () => {
    if (entryType === "Grade") {
      // For Grade, check if grade is selected
      if (!selectedGrade) {
        setOpenMissingScoreDialog(true);
      } else {
        setOpenPopup(true);
      }
    } else {
      // For Marks, check if marks are entered
      if (totalMarks > 0 && inputField.obtainedMarks === "") {
        setOpenMissingScoreDialog(true);
      } else {
        setOpenPopup(true);
      }
    }
  };

  // Render marks input or grade dropdown based on entryType
  const renderMarksOrGradeInput = () => {
    if (entryType === "Grade" && gradeScale && gradeScale.grades) {
      // Show grade dropdown
      return (
        <div className="mb-3">
          <div
            className="mb-2 marks_AR"
            style={{ fontWeight: 600, color: "#475569" }}
          >
            Assigned Grade:
          </div>
          <select
            className="form-select"
            value={selectedGrade}
            onChange={(e) => {
              const grade = gradeScale.grades.find(
                (g) => g.grade === e.target.value,
              );
              if (grade) {
                handleGradeSelect(grade);
              }
            }}
            style={{
              borderRadius: "10px",
              border: "1px solid #e2e8f0",
              padding: "10px 14px",
            }}
          >
            <option value="">Select Grade</option>
            {gradeScale.grades.map((grade) => (
              <option key={grade.grade} value={grade.grade}>
                {grade.grade} ({grade.minMarks} - {grade.maxMarks} marks) -{" "}
                {grade.resultStatus}
              </option>
            ))}
          </select>

          {/* Show grade badges */}
          <div className="d-flex gap-1 mt-2 flex-wrap">
            {gradeScale.grades.map((grade) => (
              <span
                key={grade.grade}
                className="badge"
                style={{
                  backgroundColor:
                    selectedGrade === grade.grade
                      ? grade.resultStatus === "Pass"
                        ? "#28a745"
                        : "#dc3545"
                      : grade.resultStatus === "Pass"
                        ? "#d4edda"
                        : "#f8d7da",
                  color:
                    selectedGrade === grade.grade
                      ? "#fff"
                      : grade.resultStatus === "Pass"
                        ? "#155724"
                        : "#721c24",
                  padding: "6px 12px",
                  borderRadius: "8px",
                  fontSize: "12px",
                  fontWeight: 600,
                  border:
                    selectedGrade === grade.grade
                      ? "2px solid #6366f1"
                      : "1px solid #e2e8f0",
                  cursor: "pointer",
                }}
                onClick={() => handleGradeSelect(grade)}
              >
                {grade.grade}: {grade.minMarks}-{grade.maxMarks}
              </span>
            ))}
          </div>

          {/* Show marks based on selected grade */}
          {selectedGrade && (
            <div className="mt-2 text-muted" style={{ fontSize: "13px" }}>
              <strong>Marks:</strong> {obtainedMarks || 0} / {totalMarks}
            </div>
          )}
        </div>
      );
    } else {
      // Show marks input (default)
      return (
        <div className="mb-3">
          <div
            className="mb-2 marks_AR"
            style={{ fontWeight: 600, color: "#475569" }}
          >
            Marks Obtained:
          </div>
          <input
            id="addMarks"
            type="text"
            className="form-control btn"
            placeholder="Enter marks"
            value={inputField.obtainedMarks}
            onChange={(e) => {
              let value = e.target.value;
              if (/^\d*$/.test(value) || value === "") {
                const maxValue = Number(totalMarks) || 0;
                if (value === "" || parseInt(value) <= maxValue) {
                  setInputField({
                    ...inputField,
                    obtainedMarks: value,
                  });
                } else {
                  setInputField({
                    ...inputField,
                    obtainedMarks: maxValue.toString(),
                  });
                }
              }
            }}
            style={{
              borderRadius: "10px",
              border: "1px solid #e2e8f0",
            }}
          />
        </div>
      );
    }
  };

  return reviewSdata ? (
    <div
      className="orange-scrollBar"
      style={{ overflowY: "auto", height: "600px" }}
    >
      <div>
        {/* ═══════════════════════════════════════════════════
            MODERN HEADER
            ═══════════════════════════════════════════════════ */}
        <div className="d-flex align-items-center gap-3 w-100 mb-3">
          <NavLink
            to={`/StudentListActivity`}
            className="link"
            state={{ reviewActivity_id: state.reviewActivity_id }}
          >
            <div
              style={{
                cursor: "pointer",
                width: "36px",
                height: "36px",
                borderRadius: "10px",
                background: "#f1f5f9",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <img
                className="Pointer"
                src="/images/Back Arrow.svg"
                alt=""
                style={{ width: "18px" }}
              />
            </div>
          </NavLink>

          <div className="d-flex flex-column gap-1" style={{ flex: 1 }}>
            <div className="d-flex align-items-center gap-2 flex-wrap">
              <span
                style={{
                  fontSize: "1.25rem",
                  fontWeight: 700,
                  color: "#1e293b",
                  lineHeight: 1.3,
                }}
              >
                {reviewSdata?.activity_id?.name}
              </span>
              <span
                style={{
                  background: "#fff7ed",
                  color: "#c2410c",
                  border: "1px solid #fed7aa",
                  padding: "4px 12px",
                  borderRadius: "999px",
                  fontSize: "0.75rem",
                  fontWeight: 600,
                  textTransform: "uppercase",
                  letterSpacing: "0.4px",
                  whiteSpace: "nowrap",
                }}
              >
                {reviewSdata?.status === "review"
                  ? "On Review"
                  : reviewSdata?.status}
              </span>
              {/* 🆕 Entry Type Badge */}
              {entryType && entryType !== "None" && (
                <span
                  style={{
                    background: entryType === "Grade" ? "#6366f1" : "#28a745",
                    color: "#fff",
                    padding: "4px 12px",
                    borderRadius: "999px",
                    fontSize: "0.7rem",
                    fontWeight: 600,
                    whiteSpace: "nowrap",
                  }}
                >
                  {entryType}
                </span>
              )}
            </div>
            <span className="fw-small text-muted" style={{ fontSize: "11px" }}>
              <Link to="/PublishedHomeworkActivity" className="link">
                <span style={{ color: "#64748b" }}>On review</span>
              </Link>
              {" / "}
              <NavLink
                to={`/StudentListActivity`}
                className="link"
                state={{ reviewActivity_id: state.reviewActivity_id }}
              >
                <span style={{ color: "#64748b" }}>
                  {reviewSdata?.activity_id?.name}
                </span>
              </NavLink>
              {" / "}
              <span style={{ color: "#92400e", fontWeight: 600 }}>
                {reviewSdata?.student_id?.name}
              </span>
            </span>
          </div>

          {/* 🆕 Grade/Marks Info Box */}
          <div
            className="d-flex align-items-center gap-2"
            style={{
              background: "#f8fafc",
              border: "1px solid #e2e8f0",
              padding: "8px 16px",
              borderRadius: "10px",
              whiteSpace: "nowrap",
            }}
          >
            {entryType === "Grade" && gradeScale ? (
              <>
                <span
                  style={{
                    fontSize: "0.8rem",
                    color: "#64748b",
                    fontWeight: 500,
                  }}
                >
                  Grade Scale:
                </span>
                <span
                  style={{
                    fontSize: "0.9rem",
                    fontWeight: 700,
                    color: "#4338ca",
                  }}
                >
                  {gradeScale.name}
                </span>
              </>
            ) : (
              <>
                <span
                  style={{
                    fontSize: "0.8rem",
                    color: "#64748b",
                    fontWeight: 500,
                  }}
                >
                  Total Marks
                </span>
                <span
                  style={{
                    fontSize: "1.1rem",
                    fontWeight: 700,
                    color: "#0f172a",
                  }}
                >
                  {totalMarks}
                </span>
              </>
            )}
          </div>
        </div>

        <div className="mt-1 d-flex align-items-center mb-3">
          <span style={{ fontWeight: 600, color: "#475569" }}>
            {reviewSdata?.activity_id?.subject_id?.name}
          </span>
        </div>

        {/* ═══════════════════════════════════════════════════
            STUDENT ANSWER CARD (QUESTION SECTION)
            ═══════════════════════════════════════════════════ */}
        <div
          style={{
            backgroundColor: "#f8f9fa",
            border: "1px solid #e9ecef",
            borderRadius: "12px",
            padding: "20px",
            marginBottom: "20px",
            width: "96%",
          }}
        >
          <div
            style={{
              fontSize: "0.8rem",
              fontWeight: 700,
              color: "#6c757d",
              textTransform: "uppercase",
              letterSpacing: "0.6px",
              marginBottom: "14px",
              borderBottom: "1px solid #dee2e6",
              paddingBottom: "8px",
            }}
          >
            📝 Student Answer
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginBottom: "12px",
            }}
          >
            <span
              style={{ fontWeight: 600, color: "#475569", fontSize: "14px" }}
            >
              Submitted Response
            </span>
            <span
              style={{
                background: "#fff7ed",
                color: "#c2410c",
                border: "1px solid #fed7aa",
                padding: "4px 12px",
                borderRadius: "999px",
                fontSize: "0.75rem",
                fontWeight: 600,
              }}
            >
              {entryType === "Grade" ? "Grade Based" : `${totalMarks} Marks`}
            </span>
          </div>

          <div
            className="student_answer_container_hw p-3"
            style={{
              width: "100%",
              background: "#ffffff",
              borderRadius: "10px",
              border: "1px solid #e2e8f0",
              marginBottom: "16px",
            }}
          >
            <span
              className="student_answer_question_hw"
              style={{
                whiteSpace: "pre-wrap",
                lineHeight: 1.7,
                color: "#475569",
                fontSize: "14px",
                display: "block",
              }}
            >
              {reviewSdata?.description || "No answer provided"}
            </span>
          </div>

          {/* Student Attachments */}
          <div className="pdf_container_activity_review d-flex flex-wrap gap-2">
            {reviewSdata?.attachments?.length !== 0 &&
              reviewSdata?.attachments?.map((attachments, idx) => (
                <PdfQTypeActivity
                  key={idx}
                  publishedAttachData={reviewSdata}
                  attachments={attachments}
                />
              ))}
          </div>
        </div>

        {/* ═══════════════════════════════════════════════════
            TEACHER REVIEW CARD (ANSWER SECTION)
            ═══════════════════════════════════════════════════ */}
        <div
          style={{
            backgroundColor: "#ffffff",
            border: "2px solid #d0d7de",
            borderRadius: "12px",
            padding: "20px",
            marginBottom: "20px",
            width: "96%",
          }}
        >
          <div
            style={{
              fontSize: "0.8rem",
              fontWeight: 700,
              color: "#6c757d",
              textTransform: "uppercase",
              letterSpacing: "0.6px",
              marginBottom: "16px",
              borderBottom: "1px solid #dee2e6",
              paddingBottom: "8px",
            }}
          >
            ✍️ Teacher Review
          </div>

          {/* 🆕 Render Marks Input or Grade Dropdown */}
          {renderMarksOrGradeInput()}

          {/* Teacher Comment */}
          <div className="mb-3">
            <div
              className="mb-2 marks_AR"
              style={{ fontWeight: 600, color: "#475569" }}
            >
              Teacher Comment:
            </div>
            <Form.Control
              as="textarea"
              placeholder="Enter your remark here..."
              maxLength={250}
              rows={4}
              className="px-3 py-2"
              value={inputField.addComment}
              onChange={(e) => {
                const value = e.target.value;
                if (value.trim() !== "" || value === "") {
                  setInputField({
                    ...inputField,
                    addComment: value,
                  });
                }
              }}
              style={{
                borderRadius: "10px",
                border: "1px solid #e2e8f0",
                resize: "none",
              }}
            />
          </div>

          {/* Attach File */}
          <div className="mt-3 d-flex align-items-center justify-content-between">
            <input
              id="attachFile"
              type="file"
              accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
              style={{ display: "none" }}
              onChange={handleFileChange}
            />
            <label
              className="d-flex align-items-center gap-1"
              htmlFor="attachFile"
              style={{ cursor: "pointer", marginBottom: 0 }}
            >
              <div
                className="py-2 px-3 d-flex align-items-center justify-content-center prered_attach box"
                style={{
                  background: "#f1f5f9",
                  borderRadius: "8px",
                  border: "1px dashed #cbd5e1",
                }}
              >
                <img src="/images/Attach.svg" alt="" />
                <span
                  className="activity_attach"
                  style={{ fontWeight: 500, color: "#475569" }}
                >
                  &nbsp;Attach File
                </span>
              </div>
            </label>
          </div>

          {!isValidFileType && (
            <p
              id="errorMsg"
              style={{
                color: "#dc2626",
                fontSize: "12px",
                marginTop: "8px",
                background: "#fef2f2",
                padding: "8px 12px",
                borderRadius: "8px",
                border: "1px solid #fecaca",
              }}
            >
              ⚠️ Please upload a file with a valid extension (pdf, jpg, jpeg,
              png, pptx, ppt, mp3, mp4). Max file size: 10MB.
            </p>
          )}

          {/* Attached Files Preview */}
          <div className="mt-2 p-1 onreview_pdf_activity d-flex flex-wrap">
            {attach &&
              attach.length !== 0 &&
              attach.map((attachment, index) => (
                <div key={index} style={{ margin: "10px" }}>
                  <AttachActivity
                    closeAttach={setInputField}
                    activityState={inputField}
                    attachArr={attach}
                    attachMent={attachMent}
                    setAttachment={setAttachment}
                    newActivity={reviewSdata}
                    attach={attachment}
                    indexToRemove={index}
                  />
                </div>
              ))}
          </div>

          {/* Correct Answer Section */}
          <div
            className="mb-2 mt-4 marks_AR"
            style={{ fontWeight: 600, color: "#475569" }}
          >
            Correct Answer:
          </div>
          <div
            className="hw_mcq_option_box d-flex align-items-center"
            style={{ marginBottom: "20px" }}
          >
            <input
              className="hw_add_reason"
              placeholder="Correct Answer"
              value={reviewSdata?.activity_id?.correctAnswer?.explanation}
              maxLength="250"
              disabled={true}
              style={{
                width: "100%",
                borderRadius: "10px",
                border: "1px solid #e2e8f0",
                background: "#f8fafc",
                padding: "12px",
                color: "#475569",
              }}
            />
          </div>

          {/* Correct Answer Attachments */}
          <div className="mt-2 p-1 onreview_pdf_activity d-flex flex-wrap">
            {reviewSdata?.activity_id?.correctAnswer?.attachment &&
              reviewSdata?.activity_id?.correctAnswer?.attachment.length !==
                0 &&
              reviewSdata?.activity_id?.correctAnswer?.attachment.map(
                (attachment, index) => (
                  <div key={index} style={{ marginRight: "5px" }}>
                    <PdfQTypeActivity attachments={attachment} />
                  </div>
                ),
              )}
          </div>
        </div>

        {/* ═══════════════════════════════════════════════════
            ACTION BUTTONS
            ═══════════════════════════════════════════════════ */}
        <div
          className="mt-4 d-grid gap-3 d-md-flex justify-content-md-end"
          style={{ width: "96%", paddingBottom: "20px" }}
        >
          <NavLink
            to={`/StudentListActivity`}
            className="link"
            state={{ reviewActivity_id: state.reviewActivity_id }}
          >
            <button
              className="btn py-2 closeButtonActivity"
              type="button"
              style={{
                borderRadius: "10px",
                border: "1px solid #e2e8f0",
                padding: "8px 24px",
                fontWeight: 600,
              }}
            >
              Close
            </button>
          </NavLink>
          <button
            className="btn px-4 py-2 Next_button_publicAct"
            onClick={() => CheckUnAttemptedQuestionsByTeacher()}
            style={{
              borderRadius: "10px",
              fontWeight: 600,
            }}
          >
            Submit Review
          </button>
        </div>
      </div>

      {/* Success Popup */}
      {success && (
        <SuccessfullReviewActivity
          path={navigate("/StudentListActivity", {
            state: { reviewActivity_id: state.reviewActivity_id },
          })}
        />
      )}

      {/* Confirmation Popup */}
      {openPopup && (
        <ConfiramationPopup
          setOpenPopup={setOpenPopup}
          handleSubmit={handleSubmit}
        />
      )}

      {/* Inline Loader */}
      {inProgress && (
        <div
          className="d-flex flex-column align-items-center justify-content-center"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(255,255,255,0.7)",
            zIndex: 9999,
            backdropFilter: "blur(2px)",
          }}
        >
          <img
            className="qList_loader"
            src="/gif/LoaderDot.gif"
            alt=""
            style={{ height: "50px" }}
          />
          <div className="mt-2 text-muted" style={{ fontSize: "13px" }}>
            Submitting review...
          </div>
        </div>
      )}

      {/* 🆕 Updated Missing Score Dialog */}
      <Dialog
        open={openMissingScoreDialog}
        onClose={() => setOpenMissingScoreDialog(false)}
      >
        <DialogTitle sx={{ fontWeight: "bold", color: "blue" }}>
          {entryType === "Grade" ? "Pending Grade" : "Pending Marks"}
        </DialogTitle>

        <DialogContent>
          <DialogContentText sx={{ mb: 2 }}>
            {entryType === "Grade"
              ? "Please select a grade before submitting the review."
              : "For this activity missing marks. Please review them before submitting."}
          </DialogContentText>

          <Box
            sx={{
              mb: 2,
              p: 2,
              border: "1px solid #e5e7eb",
              borderRadius: "8px",
              backgroundColor: "#f9fafb",
            }}
          >
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: "bold", mb: 1, color: "gray.700" }}
            >
              {entryType === "Grade"
                ? "Grade is still pending for this student."
                : "Marks are still pending for the following questions:"}
            </Typography>
          </Box>

          <DialogContentText
            sx={{
              fontWeight: "bold",
              color: "red",
              border: "1px solid #f87171",
              borderRadius: "8px",
              padding: "8px",
              backgroundColor: "#fee2e2",
            }}
          >
            ⚠️ Important Note: If you continue, This activity will be marked as{" "}
            <strong>{entryType === "Grade" ? "No Grade" : "0 marks"}</strong>.
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              setOpenMissingScoreDialog(false);
              setOpenPopup(true);
            }}
          >
            Continue
          </Button>
          <Button
            variant="outlined"
            onClick={() => setOpenMissingScoreDialog(false)}
          >
            Go Back
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  ) : (
    <></>
  );
};

export default QuestionnoboxC;
